import React, { useState } from "react";
import HeaderComponent from "components/card/HeaderComponent";
import { LucideUsers } from "lucide-react";
import SelectTeamCard from "./SelectTeamCard";

export default function SelectTeam( {selectedMembers = [], setSelectedMembers }) {
 
  return (
    <div className="flex flex-col">
      <HeaderComponent
        title="Step 2: Select Team"
        description={`${selectedMembers.length} members selected`}
        bgcolor="bg-gradient-to-br from-emerald-50 to-cyan-50"
        icon={<LucideUsers className="text-white" size={20}/>}
        colorTheme="gradient-cyan"
        rightNav={<div className="px-3 py-1 rounded-full bg-emerald-500 text-white text-[12px] font-semibold"
          >
              {`${selectedMembers.length}`}
          </div>}
      >
        <SelectTeamCard
          selectedMembers={selectedMembers}
          setSelectedMembers={setSelectedMembers}
        />
        
      </HeaderComponent>
    </div>
  );
}
